import { WebAddinPlatforms } from "@/common/enums";

export const TokenIPlatformService = "IPlatformService";

export interface IPlatformService {
    GetCurrentPlatform(): WebAddinPlatforms;
    GetPlatformString(): string;
    GetDateTimeOffset(): number;
    IsSetSupported(name: string, minVersion?: string): boolean;
}